import { render, staticRenderFns } from "./CertificateField.vue?vue&type=template&id=5023fbfa&"
import script from "./CertificateField.vue?vue&type=script&lang=js&"
export * from "./CertificateField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports